const mode = {
    EXPANDED: 'expanded', // existing desktop layouts for bdata-react-mini-scoreboard
    MOBILE: 'mobile', // existing mobile layouts for bdata-react-mini-scoreboard
    GAMEDAY: 'gameday', // layout for Gameday 5
    INFINITY: 'infinity', // mini scoreboard
    VERTICAL: 'vertical' // vertical gameday scoreboard
};

export const layoutConfig = {
    'gameday': 'controloverflow',
    'infinity': 'controloverflow',
};

export default mode;